import useEscapeListener from 'effects/useEscapeListener';
import React, {createRef, FC, ReactNode} from 'react';
//icons
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

type SelfAlign = 'left' | 'center' | 'right' | 'none';
type DialogSize = 'small' | 'normal' | 'large' | 'full-width';

export interface IProps {
  style?: object;
  title?: string;
  size?: DialogSize;
  closeOnFadeClick?: boolean;
  isProcessing?: boolean;
  onClose?: () => void;
  children: ReactNode;
  selfAlign?: SelfAlign;
}

export const Modal: FC<IProps> = ({
  style = {
    display: 'block',
    backgroundColor: 'rgba(0,0,0,0.75)',
  },
  title = null,
  size = 'normal',
  closeOnFadeClick = false,
  isProcessing = false,
  onClose,
  children,
  ...props
}) => {
  const modalElement = createRef<HTMLDivElement>();

  useEscapeListener(modalElement, () => {
    if (onClose) {
      onClose();
    }
  });

  const dialogSizeClass = getDialogSizeClass(size);
  const currSelfAlign = getSelfAlign(props.selfAlign || 'center');

  return (
    <div className="modal d-flex fade show" style={style} onClick={closeOnFadeClick ? onClose : undefined}>
      <div
        className={`modal-dialog modal-dialog-scrollable flex-fill ${currSelfAlign}` + dialogSizeClass}
        role="document">
        <div className="modal-content modal-body border-0 rounded-0 p-0" onClick={(event) => event.stopPropagation()}>
          {title && (
            <div className="modal-header rounded-0 bg-info text-white">
              <h5 className="modal-title text-white">
                {title}
                {isProcessing && <FontAwesomeIcon icon={faSpinner} pulse className="mx-2" />}
              </h5>
              {onClose && (
                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                  <span aria-hidden="true" className="text-white">
                    &times;
                  </span>
                </button>
              )}
            </div>
          )}
          <div className={`${title ? 'modal-body-container p-3' : ''}`}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const getSelfAlign = (align: SelfAlign) => {
  if (align === 'left') return 'align-self-start';
  if (align === 'right') return 'align-self-end';
  if (align === 'center') return 'align-self-center';
  if (align === 'none') return '';
};

const getDialogSizeClass = (size: DialogSize) => {
  if (size === 'small') return ' modal-sm';
  if (size === 'large') return ' modal-lg';
  if (size === 'full-width') return ' modal-full-width';
  return '';
};
